import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify';
import VueParticles from "vue-particles";
import CoolLightBox from 'vue-cool-lightbox';
import VueScrollactive from 'vue-scrollactive';
import './assets/scss/main.scss'
import '@mdi/font/css/materialdesignicons.css'
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'

Vue.config.productionTip = false;

// Habilita partículas somente em telas grandes
if (typeof window === 'undefined' || window.matchMedia('(min-width: 1025px)').matches) {
  Vue.use(VueParticles);
}

Vue.use(CoolLightBox);
Vue.use(VueScrollactive);

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')